/*
  Full-screen image zoom cloned from theme 50 / us.afnan.com (Prestige's ProductGallery
  lightbox): PhotoSwipe 5 (assets/photoswipe.min.js, the exact file theme 50 ships), plain
  background, no top toolbar, three round buttons at the bottom (previous / close / next),
  swipe between photos, pinch or click to zoom up to the editor's max level, zoom-from-
  thumbnail open animation. Replaces Dawn's stacked-image modal and hover magnifier when
  the "Zoom pantalla completa" setting is on (media-gallery.pg-lightbox).
*/
const ICONS = {
  close: '<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"/></svg>',
  prev: '<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"/></svg>',
  next: '<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"/></svg>',
};

function largestSource(img) {
  const candidates = (img.getAttribute('srcset') || '')
    .split(',')
    .map((part) => part.trim().split(/\s+/))
    .filter(([url, size]) => url && size && size.endsWith('w'))
    .map(([url, size]) => ({ url, width: parseInt(size, 10) }))
    .sort((a, b) => b.width - a.width);
  return candidates[0]?.url || img.currentSrc || img.src;
}

async function openLightbox(gallery, startItem) {
  const items = Array.from(gallery.querySelectorAll('[id^="GalleryViewer"] li[data-media-id]')).filter((li) =>
    li.querySelector('.product__modal-opener--image img')
  );
  if (!items.length) return;

  const dataSource = items.map((li) => {
    const img = li.querySelector('.product__modal-opener--image img');
    return {
      element: img,
      src: largestSource(img),
      msrc: img.currentSrc || img.src,
      width: parseInt(img.getAttribute('width'), 10) || img.naturalWidth || 1500,
      height: parseInt(img.getAttribute('height'), 10) || img.naturalHeight || 1500,
      alt: img.alt,
    };
  });

  const { default: PhotoSwipe } = await import(window.pgPhotoSwipeUrl);
  const pswp = new PhotoSwipe({
    dataSource,
    index: Math.max(0, items.indexOf(startItem)),
    bgOpacity: 1,
    maxZoomLevel: parseFloat(gallery.dataset.pgZoomLevel) || 3,
    arrowPrev: false,
    arrowNext: false,
    counter: false,
    close: false,
    zoom: false,
  });

  pswp.addFilter('thumbEl', (thumbEl, data) => data.element || thumbEl);
  pswp.addFilter('placeholderSrc', (src, slide) => slide.data.msrc || src);

  pswp.on('uiRegister', () => {
    const many = dataSource.length > 1;
    if (many) {
      pswp.ui.registerElement({
        name: 'pg-prev',
        className: 'pg-circle-button',
        ariaLabel: 'Anterior',
        order: 1,
        isButton: true,
        html: ICONS.prev,
        onClick: () => pswp.prev(),
      });
    }
    pswp.ui.registerElement({
      name: 'pg-close',
      className: 'pg-circle-button pg-circle-button--xl',
      ariaLabel: 'Cerrar',
      order: 2,
      isButton: true,
      html: ICONS.close,
      onClick: () => pswp.close(),
    });
    if (many) {
      pswp.ui.registerElement({
        name: 'pg-next',
        className: 'pg-circle-button',
        ariaLabel: 'Siguiente',
        order: 3,
        isButton: true,
        html: ICONS.next,
        onClick: () => pswp.next(),
      });
    }
  });

  pswp.init();
}

// Triggers exactly like us.afnan.com / theme 50 (verified on both):
//  - desktop (>=750px): clicking the photo opens the zoom; no magnifier icon is shown.
//  - mobile: ONLY the magnifier button (top-right) opens it; tapping the photo does nothing,
//    so swiping between photos never opens the zoom by accident.
// Capture phase on document runs before Dawn's modal-opener listener, so its stacked-image
// modal never opens while this zoom is enabled.
const desktop = window.matchMedia('(min-width: 750px)');

document.addEventListener(
  'click',
  (event) => {
    const gallery = event.target.closest('media-gallery.pg-lightbox');
    if (!gallery) return;
    const opener = event.target.closest('.product__modal-opener--image');
    if (!opener) return;
    const viaIcon = event.target.closest('.product__media-icon');
    if (!desktop.matches && !viaIcon) {
      // Mobile tap on the photo: swallow it (no Dawn modal), like Afnan.
      if (event.target.closest('.product__media-toggle')) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
      return;
    }
    const item = opener.closest('li[data-media-id]');
    if (!item) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openLightbox(gallery, item);
  },
  true
);

// The magnifier is a decorative span in Dawn's markup; make it a real, labelled button here.
function upgradeIcons(root = document) {
  root.querySelectorAll('media-gallery.pg-lightbox .product__modal-opener--image .product__media-icon').forEach((icon) => {
    if (icon.hasAttribute('role')) return;
    icon.setAttribute('role', 'button');
    icon.setAttribute('tabindex', '0');
    icon.setAttribute('aria-label', 'Ampliar imagen');
    icon.removeAttribute('aria-hidden');
    icon.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        icon.click();
      }
    });
  });
}
upgradeIcons();
new MutationObserver(() => upgradeIcons()).observe(document.body, { childList: true, subtree: true });
